// Note: ICON Source: https://icons.getbootstrap.com/

import { Nav } from "react-bootstrap";
import InputWithLabel from "./inputWithLabel";

// @ts-ignore
export default function TabWithFilter({
  tabs,
  filterInputId,
  filterPlaceholder = "Search",
  filterRegister,
}) {
  if (!tabs || tabs?.length === 0) {
    console.error(`Invalid tabs! TabWithFilter`);
    return null;
  }

  // If filterInputId is provided, filterRegister must also be provided
  if (filterInputId && !filterRegister) {
    console.error(`Invalid filterRegister! filterInputId provided but filterRegister is missing. TabWithFilter`);
    return null;
  }

  return (
    <div className="d-flex flex-row" style={{ marginBottom: 5 }}>
      <Nav
        variant="tabs"
        style={{ display: "flex", flexBasis: 300, flexGrow: 1, alignItems: "flex-end" }}
      >
        {tabs?.map((tab) => {
          return (
            <Nav.Item key={tab.label}>
              <Nav.Link onClick={tab.onClick} active={tab.active}>
                {tab.label}
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
      {filterInputId ? (  
        <>
        <div
          className="d-none d-md-flex"
          style={{
            display: "flex",
            flexBasis: 200,
            flexGrow: 0,
            paddingLeft: 10,
            justifyContent: "flex-end",
            marginBottom: -5,
          }}
        >
          <InputWithLabel
            inputId={filterInputId}
            placeholder={filterPlaceholder}
            type="text"
            register={filterRegister}
            wrapperClass={null}
          />
        </div>
      </> ) : null}
    </div>
  );
}
